import React from 'react';
import searchIcon from '../icons/non-prefilled/16x16/search.svg';
import styles from './SearchInput.module.scss';
import SVGIcon from './SVGIcon';

interface SearchInputProps {
  autoFocus?: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  value?: string;
}

const SearchInput = React.forwardRef(
  (
    {
      autoFocus = undefined,
      onChange,
      placeholder = 'Search',
      value = '',
    }: SearchInputProps,
    ref: React.Ref<HTMLInputElement>,
  ) => {
    return (
      <label className={styles.container}>
        <SVGIcon className={styles.icon}>{searchIcon}</SVGIcon>
        <input
          aria-label="Search"
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={autoFocus}
          className={styles.input}
          onChange={onChange}
          type="text"
          ref={ref}
          placeholder={placeholder}
          value={value}
        />
      </label>
    );
  },
);

export default SearchInput;
